import React, { useEffect } from "react";
// import contactImg from "../career/img/career.png";
import Pageheading from "../../components/PageHeading/Pageheading.jsx";
import { RiHome2Line } from "react-icons/ri";
import Mediasection from "../../components/services/Mediasection.jsx";
import ReversedSection from "../../components/services/ReversedSection.jsx";
import Heading from "../../components/Highlightedheading/Heading.jsx";
import { serviceAssets } from "../../assets/services/index.js";
import { useWindowSize } from "react-use";
import contactImg from "../../assets/services/career2.png";
import mobileImg from "../../assets/services/service_mobile.png";
import BannerHeading from "../../components/BannerHeading/Heading";

const Services = () => {
  const { width } = useWindowSize();

  useEffect(() => {
    const preloadImages = [contactImg, mobileImg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="w-full h-full  text-white">
      <div className="relative w-full  h-[90vh] md:h-[40vw] flex items-center">
        <div
          className={`absolute inset-0 ${
            width < 768 ? "bg-cover" : "bg-cover"
          } bg-no-repeat bg-bottom flex justify-center items-center z-20`}
          style={{
            backgroundImage: `url(${width < 768 ? mobileImg : contactImg})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[15vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"SERVICES"} />
          </div>
          <div className="h-[100px] absolute top-full bg-gradient-to-b from-[#121614] w-full"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-20 h-[52vw]">
          <div className="pl-4 md:pl-[5.63vw] flex items-center pt-[25vw] md:pt-[10.29vw]">
            <Pageheading pageHeading={"Services"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>

      <div className="relative pt-[60px] md:pt-[100px] 3xl:pt-[120px] space-y-[40px] md:space-y-[50px]">
        <Mediasection
          imgSrc={serviceAssets.Service6}
          leftMediaText="R.A.T Films x AI: The Future of Storytelling"
          rightMediaText="At R.A.T Films, we’re using AI to redefine storytelling. From AI-generated visuals to editing and VFX, we blend technology with narratives. Our AI workflows save time, elevate quality and deliver commercially impactful content."
          reverse
        />

        <ReversedSection
          customCSs={"md:pt-[8.24vh]"}
          imgSrc={serviceAssets.Service1}
          leftMediaText="Complete Film and Media Production Services"
          rightMediaText="We are one of the leading Film production companies in India."
        />

        <Mediasection
          imgSrc={serviceAssets.Service2}
          leftMediaText="Creative Lab"
          rightMediaText="Content creation for the brand. An innovative Hybrid model where we break the barriers by bringing the best innovative creative minds to generate some really cool ideas to tell your brand's stories."
        />

        <ReversedSection
          imgSrc={serviceAssets.Service3}
          leftMediaText="Line Production and Project Management"
          rightMediaText="We offer Industries best line production services with a total turn key solutions. Getting the best crew possible for the project to execute it seamlessly and without any hassles."
        />

        <Mediasection
          imgSrc={serviceAssets.Service4}
          leftMediaText="360 Degree Media Innovation"
          rightMediaText="Strategising and Innovating a comprehensive media possibilities. Creating Unique Brand Touch points and creating HIIT ( High Impact Innovative Targets ) to maximise your brand exposure"
          reverse
        />

        <ReversedSection
          customCSs={"md:pb-[9.26vh]"}
          imgSrc={serviceAssets.Service5}
          leftMediaText="Brand Development"
          rightMediaText="We help you build your brand. Be it scaling it up or launching it in the best possible way."
        />
      </div>
    </div>
  );
};

export default Services;
